export default {
  "content": "<path fill=\"#1371C8\" d=\"M15.404 1.18a1.748 1.748 0 010 2.475l-.937.94-3.063-3.06.941-.94a1.75 1.75 0 012.475 0l.584.585zM5.47 7.47l5.228-5.23 3.063 3.062-5.232 5.228c-.19.194-.425.338-.684.425l-2.775.925c-.297.088-.566.02-.769-.21-.2-.174-.268-.47-.181-.74l.925-2.775c.088-.26.231-.493.425-.684zm.613-5.58c.553 0 1 .476 1 1 0 .58-.447 1-1 1h-3c-.553 0-1 .475-1 1v8.028a1 1 0 001 1h8a1 1 0 001-1V9.89c0-.525.446-1 1-1 .553 0 1 .475 1 1v3.028a3 3 0 01-3 3h-8a3 3 0 01-3-3V4.89a3 3 0 013-3h3z\"/>",
  "attrs": {
    "xmlns": "http://www.w3.org/2000/svg",
    "width": "16",
    "height": "16",
    "fill": "none",
    "viewBox": "0 0 16 16"
  }
};